import React from "react";
import PropTypes from "prop-types";

const HeaderGlobal = ({ hTitle, hShortText, hText, hNum, bkgImage }) => {
  return (
    <header className="m-headerMarkets">
      <div className="_wr m-headerMarkets__wrapper" style={{ backgroundImage: `url("${bkgImage}")` }}>
        <div className="_w m-headerMarkets__content">
          <div className="_12 _xs11 _m7 _xl5 ">
            <h1 className="m-headerMarkets__content--title">{hTitle}</h1>
            {hShortText ? <p className="a-text -red">{hShortText}</p> : ""}
            <div className="m-headerMarkets__numText">
              <span className="m-headerMarkets__numText--num">
                {hNum}%
              </span>
              <p className="m-headerMarkets__numText--text">{hText}</p>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

HeaderGlobal.defaultProps = {
  hTitle: "Lorem ipsum",
  hTextOne:
    "Lorem ipsum dolor sit amet consectetur adipisicing elit. Ea, tempore?",
};

HeaderGlobal.propTypes = {
  hTitle: PropTypes.string,
  hShortText: PropTypes.string,
  hText: PropTypes.string,
};

export default HeaderGlobal;
